var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-wrapper" }, [
    _vm.confirmMessage
      ? _c("div", { staticClass: "bundle-popup" }, [
          _c("div", { staticClass: "message" }, [
            _c("p", [_vm._v(_vm._s(_vm.confirmMessage))]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "buttons" },
              _vm._l(_vm.confirmButtons, function(b, i) {
                return _c(
                  "button",
                  {
                    key: "button-" + i,
                    staticClass: "btn btn-outline",
                    on: { click: b.action }
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(b.text) +
                        "\n                "
                    )
                  ]
                )
              }),
              0
            )
          ])
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "padded" }, [
        _c("div", { staticClass: "center-text" }, [
          _c("h2", [_vm._v(_vm._s(_vm.headlines.mainHeadline))]),
          _vm._v(" "),
          _c("p", [_vm._v(_vm._s(_vm.headlines.mainDescription))])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container" }, [
      _c(
        "div",
        { staticClass: "padded" },
        [
          _c("section-title", {
            attrs: { text: _vm.headlines.section1Heading }
          }),
          _vm._v(" "),
          _c("section-sub-title", {
            attrs: { text: _vm.headlines.step1Heading }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "collection-wrapper" }, [
            _c(
              "div",
              { staticClass: "elements" },
              _vm._l(_vm.step1Products, function(p, index) {
                return _c("snowpeak-product-tile", {
                  key: "frame-" + index,
                  staticClass: "product-tile",
                  attrs: { product: p, "in-bundle": _vm.productInBundle(p) },
                  on: { "add-product": _vm.addProductToBundle }
                })
              }),
              1
            )
          ]),
          _vm._v(" "),
          _c("section-sub-title", {
            attrs: { text: _vm.headlines.step2Heading }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "collection-wrapper" }, [
            _c(
              "div",
              { staticClass: "elements" },
              _vm._l(_vm.step2Products, function(p, index) {
                return _c("snowpeak-product-tile", {
                  key: "legs-" + index,
                  staticClass: "product-tile",
                  attrs: { product: p, "in-bundle": _vm.productInBundle(p) },
                  on: { "add-product": _vm.addProductToBundle }
                })
              }),
              1
            )
          ]),
          _vm._v(" "),
          _c("section-title", {
            attrs: { text: _vm.headlines.section2Heading }
          }),
          _vm._v(" "),
          _c("section-sub-title", {
            attrs: { text: _vm.headlines.step3Heading }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "collection-wrapper" }, [
            _c(
              "div",
              { staticClass: "elements" },
              _vm._l(_vm.step3Products, function(p, index) {
                return _c("snowpeak-product-tile", {
                  key: "cooker-" + index,
                  staticClass: "product-tile",
                  attrs: { product: p, "in-bundle": _vm.productInBundle(p) },
                  on: { "add-product": _vm.addProductToBundle }
                })
              }),
              1
            )
          ]),
          _vm._v(" "),
          _c("section-sub-title", {
            attrs: { text: _vm.headlines.step4Heading }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "collection-wrapper" }, [
            _c(
              "div",
              { staticClass: "elements" },
              _vm._l(_vm.step4Products, function(p, index) {
                return _c("snowpeak-product-tile", {
                  key: "surface-" + index,
                  staticClass: "product-tile",
                  attrs: { product: p, "in-bundle": _vm.productInBundle(p) },
                  on: { "add-product": _vm.addProductToBundle }
                })
              }),
              1
            )
          ]),
          _vm._v(" "),
          _c("section-sub-title", {
            attrs: { text: _vm.headlines.step5Heading }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "collection-wrapper" }, [
            _c(
              "div",
              { staticClass: "elements" },
              _vm._l(_vm.step5Products, function(p, index) {
                return _c("snowpeak-product-tile", {
                  key: "storage-" + index,
                  staticClass: "product-tile",
                  attrs: { product: p, "in-bundle": _vm.productInBundle(p) },
                  on: { "add-product": _vm.addProductToBundle }
                })
              }),
              1
            )
          ]),
          _vm._v(" "),
          _c("section-title", {
            attrs: { text: _vm.headlines.section3Heading }
          }),
          _vm._v(" "),
          _c("section-sub-title", {
            attrs: { text: _vm.headlines.step6Heading }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "collection-wrapper" }, [
            _c(
              "div",
              { staticClass: "elements" },
              _vm._l(_vm.step6Products, function(p, index) {
                return _c("snowpeak-product-tile", {
                  key: "extension-" + index,
                  staticClass: "product-tile",
                  attrs: { product: p, "in-bundle": _vm.productInBundle(p) },
                  on: { "add-product": _vm.addProductToBundle }
                })
              }),
              1
            )
          ]),
          _vm._v(" "),
          _c("section-title", {
            attrs: { text: _vm.headlines.section4Heading }
          }),
          _vm._v(" "),
          _c("section-sub-title", {
            attrs: { text: _vm.headlines.step7Heading }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "collection-wrapper" }, [
            _c(
              "div",
              { staticClass: "elements" },
              _vm._l(_vm.step7Products, function(p, index) {
                return _c("snowpeak-product-tile", {
                  key: "case-" + index,
                  staticClass: "product-tile",
                  attrs: { product: p, "in-bundle": _vm.productInBundle(p) },
                  on: { "add-product": _vm.addProductToBundle }
                })
              }),
              1
            )
          ])
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { class: { shown: _vm.bundleShown }, attrs: { id: "your-bundle" } },
      [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "padded flex" }, [
            _c("h4", [_vm._v("Your Iron Grill Table Bundle")]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "bundle-items",
                class: { shown: _vm.bundleShown }
              },
              [
                _c(
                  "a",
                  {
                    class: { disabled: !_vm.canShiftBundleLeft },
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.shiftBundlePreview(-1)
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: { src: _vm.images.leftArrow, alt: "Expand Bundle" }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "bundle-mask" }, [
                  _vm.bundleProducts.length === 0
                    ? _c("span", [_vm._v("You have no items in your bundle")])
                    : _c(
                        "ul",
                        {
                          style: {
                            width: _vm.bundleWidth,
                            marginLeft: _vm.bundleViewShift
                          }
                        },
                        [
                          _vm._l(_vm.bundleProducts, function(p, i) {
                            return _c("li", { key: "bp-" + i }, [
                              _c(
                                "a",
                                {
                                  staticClass: "remove",
                                  attrs: { href: "#" },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.removeProductFromBundle(i)
                                    }
                                  }
                                },
                                [
                                  _c(
                                    "svg",
                                    {
                                      attrs: {
                                        width: "8",
                                        height: "9",
                                        xmlns: "http://www.w3.org/2000/svg"
                                      }
                                    },
                                    [
                                      _c(
                                        "g",
                                        {
                                          attrs: {
                                            "stroke-width": "1.125",
                                            stroke: "#2E2B2C",
                                            fill: "none",
                                            "fill-rule": "evenodd",
                                            "stroke-linecap": "square"
                                          }
                                        },
                                        [
                                          _c("path", {
                                            attrs: {
                                              d:
                                                "M.785 1.56l6.08 6.08M.785 7.64l6.08-6.08"
                                            }
                                          })
                                        ]
                                      )
                                    ]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("img", {
                                attrs: {
                                  src: p.product.images[0],
                                  alt: "Product Image"
                                }
                              }),
                              _vm._v(" "),
                              _c("p", { staticClass: "desktop-description" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(_vm.ellipsis(p.product.title))
                                ),
                                _c("br"),
                                _vm._v(
                                  "\n                                    $" +
                                    _vm._s((p.product.price / 100).toFixed(2)) +
                                    "\n                                "
                                )
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "mobile-description" }, [
                                _c("span", [_vm._v(_vm._s(p.product.title))]),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "$" +
                                      _vm._s((p.product.price / 100).toFixed(2))
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "bundle-quantity" }, [
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "#" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.changeQuantity(i, -1)
                                      }
                                    }
                                  },
                                  [_vm._v("-")]
                                ),
                                _vm._v(" "),
                                _c("span", [_vm._v(_vm._s(p.quantity))]),
                                _vm._v(" "),
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "#" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.changeQuantity(i, 1)
                                      }
                                    }
                                  },
                                  [_vm._v("+")]
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "bundle-quantity-mobile" },
                                [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: p.quantity,
                                        expression: "p.quantity"
                                      }
                                    ],
                                    attrs: { type: "number" },
                                    domProps: { value: p.quantity },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          p,
                                          "quantity",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              )
                            ])
                          }),
                          _vm._v(" "),
                          _c("li", { staticClass: "clear-bundle-li" }, [
                            _c(
                              "a",
                              {
                                attrs: { href: "#" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.clearBundle($event)
                                  }
                                }
                              },
                              [_vm._v("Clear IGT Bundle")]
                            )
                          ])
                        ],
                        2
                      )
                ]),
                _vm._v(" "),
                _c(
                  "a",
                  {
                    class: { disabled: !_vm.canShiftBundleRight },
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.shiftBundlePreview(1)
                      }
                    }
                  },
                  [
                    _c("img", {
                      attrs: {
                        src: _vm.images.rightArrow,
                        alt: "Expand Bundle"
                      }
                    })
                  ]
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "bundle-info" }, [
              _c("p", [
                _c("span", [
                  _vm._v("Total Items: " + _vm._s(_vm.bundleItemCount))
                ]),
                _c("br"),
                _vm._v(" "),
                _c("span", [_vm._v("Total Price: " + _vm._s(_vm.bundlePrice))]),
                _vm._v(" "),
                _vm.bundleShown
                  ? _c(
                      "a",
                      {
                        staticClass: "clear-bundle-link",
                        attrs: { href: "#" },
                        on: {
                          click: function($event) {
                            $event.preventDefault()
                            return _vm.clearBundle($event)
                          }
                        }
                      },
                      [_vm._v("Clear IGT Bundle")]
                    )
                  : _vm._e()
              ])
            ]),
            _vm._v(" "),
            !_vm.bundleShown
              ? _c(
                  "a",
                  {
                    staticClass: "clear-bundle-link",
                    attrs: { href: "#" },
                    on: {
                      click: function($event) {
                        $event.preventDefault()
                        return _vm.clearBundle($event)
                      }
                    }
                  },
                  [_vm._v("Clear IGT Bundle")]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "cart-link-wrapper" }, [
              _c(
                "a",
                {
                  staticClass: "btn btn-outline",
                  attrs: { href: "#" },
                  on: {
                    click: function($event) {
                      $event.preventDefault()
                      return _vm.addToCart($event)
                    }
                  }
                },
                [_vm._v("Add all to Cart")]
              )
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "bundle-preview-toggle",
                class: { shown: _vm.bundleShown },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    _vm.bundleShown = !_vm.bundleShown
                  }
                }
              },
              [
                _c("img", {
                  attrs: { src: _vm.images.upArrow, alt: "Expand Bundle" }
                })
              ]
            )
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }